import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.iframe`
    border: 0;
    height: 100%;
    width: 100%;
`

const Iframe = ({ src, ...props }) => <Wrapper title="Hubble" src={src} {...props} />

Iframe.propTypes = {
    src: PropTypes.string,
}

Iframe.defaultProps = {
    src: '',
}

export default Iframe
